<template>
  <div class="top-hero2">
    <div class="container">
      <div id="challange-target">hidden</div>

      <div class="marginTop d-flex justify-content-md-center">
        <div class="col-md-6">
          <v-toolbar color="#01579B" class="top-hero6" dark flat>
            <v-toolbar-title>Please verify your account</v-toolbar-title>
          </v-toolbar>

          <v-app style="margin: 0; background-color: transparent;">
            <div class="card p-4 text-center">
              <h2 class="display-1">
                Thank you for registering your account with 360 Real Estate!
              </h2>
              <br />
              <hr />
              <b class="mt-4 text-xl"
                >We sent a verification email to the email address you
                entered.</b
              ><br />
              Please allow up to 5 minutes for the email to be received.<br />
              <i>Please check your junk / spam if you do not see the email.</i
              ><br /><br />

              <b class="mt-4 text-xl">Still unable to login?</b>
              <div class="profile-card-ctr">
                <v-btn
                  href="tel:19106510743"
                  target="_blank"
                  class="profile-card__button button--orange text-center"
                  dark
                  >Call 360 Real Estate Support</v-btn
                >
              </div>

              <!-- <v-btn
                  class="mt-2"
                  rounded
                  color="primary"
                  dark
                  @click="resendEmail"
                >
                  Resend email verification
                </v-btn> -->
            </div>
          </v-app>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
export default {
  data() {
    return {};
  },

  methods: {
    resendEmail() {
      window.axios.post("email/resend").then(() => {
        Swal.fire({
          icon: "success",
          title: "Email successfully sent",
          text:
            "Hi Jane here, i sent you a new email. Please verify your email account",
          footer: "Check your email"
        });
      });
    }
  }
};
</script>
